/* eslint-disable @typescript-eslint/naming-convention */
import { LAYOUT_VALS } from 'src/researcher/constants/common.constants';
import { UNITS, SCREEN_UNITS } from './units';

export const tab_height = `calc(${SCREEN_UNITS.height} - ${LAYOUT_VALS.bannerHeight} - ${LAYOUT_VALS.maintenanceHeight})`;
export const tab_padding = UNITS['2pt'];
